<template>
  <div class="app-container">
    <div class="hero-container"></div>
    <div class="w-[369px] h-[686px] rounded-2xl pt-12 px-5 bg-white sm:w-[480px] sm:h-[604px] sm:px-8 content-card">
      <router-view></router-view>
    </div>
    <div class="flex justify-center items-center gap-8 footer">
      <img class="h-6" src="@/assets/heywhale-logo.svg" alt="Heywhale">
      <img class="h-8" src="@/assets/modelwhale-logo.svg" alt="Heywhale">
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
// TODO vuex typings
// @ts-ignore
import { useStore } from 'vuex'
import useLoginCheck from '@/composables/login-check'
import getQueryObject from '@/utils/get-query-object'

const router = useRouter()
const store = useStore()

onMounted(async () => {
  await useLoginCheck()
  const queries = getQueryObject()
  const oauthState = queries.oauth
  const oauthType = queries.type
  if (oauthState) {
    if (oauthType) {
      store.commit('setOAuthType', oauthType)
    }
    store.commit('setOAuthState', oauthState)
    router.push({ name: 'oauth' })
  }
})
</script>

<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
  background-image: url('@/assets/background.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: grid;
  grid-template-areas: "hero content" "footer footer";
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 48px;
  max-width: 100vw;
  max-height: 100vh;
  height: 100vh;

  @media screen and (max-width: 1200px) {
    grid-template-areas: "content" "footer";
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 48px;
    .hero-container {
      display: none;
    }
    .content-card {
      justify-self: center !important;
    }
  }
}
.hero-container {
  position: relative;
  height: 600px;
  width: 600px;
  background-image: url('@/assets/hero-icon.svg');
  background-repeat: no-repeat;
  background-size: cover;
  justify-self: center;
  align-self: center;
  grid-area: hero;
}
.content-card {
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.03),0px 16px 24px 2px rgba(0, 0, 0, 0.02),0px 8px 10px -5px rgba(0, 0, 0, 0.05);
  justify-self: center;
  align-self: center;
  grid-area: content;
}
.footer {
  grid-area: footer;
}
</style>
